import { render, staticRenderFns } from "./comment-creer-une-carte-de-visite-de-coach-sportif.vue?vue&type=template&id=15b9be91&"
import script from "./comment-creer-une-carte-de-visite-de-coach-sportif.vue?vue&type=script&lang=js&"
export * from "./comment-creer-une-carte-de-visite-de-coach-sportif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports